import { api_107_base } from "./Caller";
import { BalanceManager } from "./utils/balanceManager";
import { Formatter } from "./utils/formatter";
import { fullscreenListener } from "./utils/listener";


export class MongibelloForgeUtilities {
    private _isPlaying: boolean = false;
    private _isPlayingFreeSpin: boolean = false;
    private _isGameOn: boolean = false;
    
    constructor(private caller: api_107_base) {
        fullscreenListener();
    }

    private getBetCents(): number {
        return this.caller.getLevel() * this.caller.getCoin(); 
    }
    
    //Controllo del balance se è sufficiente per giocare
    public hasEnoughBalance(): boolean {
        if((window as any).GENERAL_CONFIG.checkCredits === false) return true
        const bet = this.getBetCents();
        const balance = BalanceManager.get();     

        const ok = bet <= balance;

        if (!ok) {
            (window as any).UIBridge?.showPopupControl("popup.insufficientBalance", false, false, false, false, 3000);
        }
    
        return ok;
    }

    public get isPlayingFreeSpin(): boolean {
        return this._isPlayingFreeSpin;
    }

    public set isPlayingFreeSpin(value: boolean) {

        if (value === true) {
            (window as any).UIBridge?.hideAll()
        } else {
            (window as any).UIBridge?.showAll();
        }
    }

    public get isPlaying(): boolean {
        return this._isPlaying;
    }

    public set isPlaying(value: boolean) {
        this._isPlaying = value;

        if (value === true) {
            this.hideAllInGame();
        }
        if ( value === false) {
            this.turnOnAllInGame();
        }   
    }

    public get isGameOn(): boolean {
        return this._isGameOn;
    }

    public set isGameOn(value: boolean) {
        this._isGameOn = value;
        this.turnOnAllInGame();
    }

    public winUpdate(win : number){
        BalanceManager.add(win);

        (window as any).UIBridge?.setBalance((window as any).FORMATTER.formatCurrency(BalanceManager.get(), true));
    }

    public winButtonUpdate(win: number){
        (window as any).UIBridge?.setWin((window as any).FORMATTER.formatCurrency(win, true));
        (window as any).UIBridge?.showWinControl();
    }
    
    private turnOnAllInGame(){
        (window as any).UIBridge?.showAll();
    }

    private hideAllInGame(){
        (window as any).UIBridge?.disableMenuButton();
        (window as any).UIBridge?.disableCoinControl();
        (window as any).UIBridge?.disableBetControl();
    }
}